import React, { Component } from "react";
import '../../styles/css/App.css';
import '../../styles/css/board.css';
import GlassCard from '../GlassCard';

class MotelTerrain extends Component{

    render(){
        return (
            <div className="rev-row ">
               
                   
                     {<div >
                             {this.props.body}
                           
                        </div>}
                
               
            </div>
            )
    }
}


export default MotelTerrain;